import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify", fontSize: "1.4rem"}}>
            以下是主要使用的<span className="purple">后期制作软件</span>、<span className="purple">AI工具</span>
            以及<span className="purple">拍摄设备</span>。
            业余时间自主开发了一系列网页工具与Adobe插件（正在施工中...），用于辅助项目管理与提升后期制作效率。
            <br />
            <br />
            同时梳理并建立了一套<span className="purple">标准化的视频制作SOP</span>及<span className="purple">后期工作流模板</span>，覆盖从素材整理到成片交付的完整流程，持续优化中。
            <br />
            <br />
            依托过往的软件开发经验，在表达式编写及 JavaScript 脚本自动化方面具备较强能力，使得后期流程在定制化、模块化和自动化方面更具效率与可扩展性!
            <br />
            <br />
          </p>


          <p style={{ color: "rgb(155 126 172)" }}>
            "Talk is cheap. Show me the code.（Work）"{" "}
          </p>
          <footer className="blockquote-footer">Linus Torvalds</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
